import { pilot } from '~/services/serviceInstances';
import { PilotId } from '~/types/PilotId';

type Request = {
  folderName: string;
  parentFolder: PilotId;
};

type ServerRequest = {
  folder_name: string;
  parent_folder: PilotId;
};

export const createFolder = async ({
  folderName,
  parentFolder,
}: Request): Promise<Response> => {
  const params: ServerRequest = {
    folder_name: folderName,
    parent_folder: parentFolder,
  };

  return pilot.post('/folder/', params);
};
